import { READY_KINDS } from 'helpers/kpiBuilder/readyRecipes';
import { BarNamesStep } from './BarNamesStep';
import { BuilderSection } from './BuilderSection';
import { GroupStep } from './GroupStep';
import { OptionChips } from './OptionChips';
import { RangesStep } from './RangesStep';
import { StepProps } from './StepProps';
import { TopN } from './TopN';
import { TraitStep } from './TraitStep';

const THRESHOLDS = [0, 50, 60, 70, 80, 90].map((n) => ({ id: n, label: n === 0 ? 'Show all' : `${n}% or more` }));

const Threshold = ({ a, patch }: StepProps) => (
  <BuilderSection title="Lowest non-completion rate to show" hint="Facilities below this share of registered learners who have not completed are left out, so only the ones that need attention show.">
    <OptionChips options={THRESHOLDS} selected={[a.threshold]} onSelect={(id) => patch({ threshold: Number(id) })} />
  </BuilderSection>
);

interface NoteProps {
  text: string;
}

const Note = ({ text }: NoteProps) => <div className="small text-secondary">{text}</div>;

// Options that change a ready-made chart. The chart itself, and its bar names, are drawn by the dashboard.
export const ReadyOptions = (p: StepProps) => {
  switch (p.a.readyKind) {
    case 'dropout':
      return (
        <>
          <GroupStep {...p} />
          <TopN {...p} />
        </>
      );
    case 'attempts':
      return <TopN {...p} />;
    case 'facility':
      return <Threshold {...p} />;
    case 'histogram':
      return (
        <>
          <RangesStep {...p} />
          <TraitStep {...p} title="Second distribution: records that…" hint="The first distribution counts every record you chose above. The second counts only the records that meet this condition, for example a content ID that is one of your assessments." />
          <BarNamesStep {...p} />
        </>
      );
    case 'completedFunnel':
      return <Note text="Learners who completed the course are the first step. The levels come from the passbook, so a level can be larger than the first step. Dashboard users pick one competency, or leave it empty for all of them." />;
    case 'levelFunnel':
      return <Note text="Everyone enrolled is the first step. Tick “Completed the course” above to start from learners who completed instead. Dashboard users pick one competency, or leave it empty for all of them." />;
    default:
      return <Note text={`Nothing more to choose: ${READY_KINDS[p.a.readyKind].summary.toLowerCase()}.`} />;
  }
};
